module.exports = __webpack_public_path__ + "static/img/pop-up.04a5ff5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pop-up.gif
// module id = rRu3
// module chunks = 0